import { css } from '@emotion/react';
import { GetPatientsBalanceResponse_PatientBalance } from '@weave/schema-gen-ts/dist/schemas/payments/messages/commands/commands.pb';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { formatCentsToCurrency } from '../../../../utils/currency-helpers';
import { BalanceTag } from '../BalanceTag';
import { RowHeader } from './row-header';
import { StartColumn } from './start-column';

type RowProps = {
  data: GetPatientsBalanceResponse_PatientBalance;
  index: number;
  selected: string[];
  onClick: (data: GetPatientsBalanceResponse_PatientBalance) => void;
};
export const Row = ({ index, data, selected, onClick }: RowProps) => {
  const { t } = useTranslation('payments');

  return (
    <div
      key={index}
      css={css`
        display: flex;
        gap: ${theme.spacing(2)};
        padding: ${theme.spacing(3, 3)};
        border-bottom: 1px solid ${theme.colors.neutral10};
        &:hover {
          background-color: ${theme.colors.neutral5};
          cursor: pointer;
        }
        .start-column {
          align-self: flex-start;
        }
        .end-column {
          align-self: flex-start;
        }
      `}
      onClick={() => onClick(data)}
    >
      <div
        css={css`
          align-self: center;
        `}
        className='start-column'
      >
        <StartColumn data={data} isSelected={selected.includes(data.patientId)} />
      </div>
      <div
        css={css`
          flex: 1;
        `}
      >
        <div
          css={css`
            margin-bottom: ${theme.spacing(2)};
          `}
          className='row-header'
        >
          <RowHeader {...data} />
        </div>
        <Text
          css={css`
            color: ${theme.colorsV2.black(75)};
          `}
          size='small'
        >
          {t('Balance')}
        </Text>
        <div
          css={css`
            display: flex;
            align-items: center;
            gap: ${theme.spacing(1)};
          `}
          className='end-column'
        >
          <Text
            css={css`
              color: ${theme.colorsV2.black(85)};
            `}
            size='medium'
          >
            {formatCentsToCurrency(data.balance)}
          </Text>
          <BalanceTag balanceType={data.balanceType} size='tiny' maxWidth='300px' />
        </div>
      </div>
    </div>
  );
};
